/** The icon set. One library, imported by name so tree-shaking works. */
export {
  // Status and priority
  AlertTriangle,   // urgent priority; service degraded
  Circle,          // pending status (filled via fill="currentColor")
  CheckCircle2,    // resolved; service healthy
  XCircle,         // service.
  MinusCircle,     // not configured / on hold — grey, never red
  Flag,            // handoff detected

  // Actions
  Search,
  Download,         // export
  Copy,
  RefreshCw,        // retry
  X,                // close
  Plus,
  Pencil,
  Trash2,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ChevronsUpDown,  // sortable column
  ExternalLink,
  MoreHorizontal,

  // Customer data
  Phone,
  Mail,
  Eye,
  EyeOff,           // masked value

  // Navigation
  LayoutDashboard,  // Overview
  MessagesSquare,   // Chatbot
  MessageCircle,    // WhatsApp (on hold)
  Mic,              // Voice agent (coming soon)
  BarChart,         // Analytics (planned)
  Users,
  Settings,
  ScrollText,       // Audit log
  PanelLeftClose,
  PanelLeftOpen,
  LogOut,

  // Account
  User,             // profile section

  // Access control
  ShieldCheck,      // roles / permissions
  ShieldAlert,      // sensitive permission
  KeyRound,         // password
  Lock,

  // Empty states
  Inbox,
  MessageSquareDashed,
  MessageSquare,
  FileQuestion,

  // Misc
  Loader2,          // spinner
  Info,
  Clock,
  Wifi,
  WifiOff,
} from 'lucide-react'

export type { LucideIcon } from 'lucide-react'

/** Sizes: 14, 16, 20, 24. Nothing else. */
export const ICON_SIZE = { xs: 14, sm: 16, md: 20, lg: 24 } as const

/** Lucide's default stroke of 2 is heavy at 14-16px against this type scale. */
export const ICON_STROKE = 1.75
